import React, { useEffect, useState } from 'react';
import { Navigate, Route, useLocation } from 'react-router-dom';
import { setAuthorization } from '../helpers/api_helper';
import { useDispatch, useSelector } from 'react-redux';
import {
    redirectToLogout,
    redirectToMenuUrl,
    setUrlToRedirect as setUrlToRedirectThunk
} from '../slices/thunks';
import { useProfile } from '../Components/Hooks/useUserHooks';
import { createSelector } from 'reselect';
import { set } from 'lodash';
import Navdata from '../Layouts/LayoutMenuData';
import { setRequireInitRedirect } from '../slices/settings/reducer';


const AuthProtected = (props) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { userProfile, loading, token } = useProfile();
    const tokenInStorage = localStorage.getItem('authUser');
    const authUser = JSON.parse(localStorage.getItem('authUser'));
    const privacyPolicyAccepted = authUser && authUser.privacy_policy;
    const [urlToRedirect, setUrlToRedirect] = useState(null);

    const selectorSettings = createSelector(
        state => state.Settings,
        result => ({
            requireInitRedirect: result.requireInitRedirect,
	        currentItemsMenu: result.currentItemsMenu || []
        })
    );

    const {
        requireInitRedirect,
        currentItemsMenu
    } = useSelector(selectorSettings);

    const shouldApplyInitRedirect = location.pathname === '/';

    const selectorProfile = createSelector(
		state => state.Profile,
		profile => ({
            establishmentActive: profile.establishmentActive,
			establishmentActiveLoaded: profile.establishmentActiveLoaded
		})
	);
	const { 
		establishmentActiveLoaded,
        establishmentActive
	} = useSelector(selectorProfile);
    
    const searchMenuItemByScope = (menuItems, scope) => {
        menuItems.map(menuItem => {
            if(menuItem.id === scope){
                setUrlToRedirect(menuItem.link);
            }
            if (menuItem?.subItems?.length) {
                const newItems = menuItem.subItems;
                searchMenuItemByScope(newItems, scope)
            }
            else if (menuItem?.childItems?.length) {
                const newItems = menuItem.childItems;
                searchMenuItemByScope(newItems, scope)
            }else{
                // nothing
            }
		})
	}

    useEffect(() => {
        if(
            // requireInitRedirect &&
            establishmentActiveLoaded &&
            userProfile?.establishment_default_id &&
            establishmentActive
        ){
            searchMenuItemByScope(
                currentItemsMenu,
                userProfile?.login_redirect_menu_scope
            );
        }
    }, [
        requireInitRedirect,
        currentItemsMenu,
        establishmentActiveLoaded
    ])

    useEffect(() => {
        if(
            urlToRedirect &&
            establishmentActiveLoaded
        ){
            dispatch(setUrlToRedirectThunk(urlToRedirect));
        }
    }, [urlToRedirect, establishmentActiveLoaded])

    useEffect(() => {
        if(
            urlToRedirect &&
            establishmentActiveLoaded &&
            shouldApplyInitRedirect &&
            requireInitRedirect
        ){
            dispatch(setRequireInitRedirect(false));
            dispatch(redirectToMenuUrl('/'));
        }
    }, [urlToRedirect, establishmentActiveLoaded, shouldApplyInitRedirect, requireInitRedirect, dispatch])

    useEffect(() => {
        if (userProfile && !loading && token) {
            setAuthorization(token);
        } else if (!userProfile && loading && !token) {
            dispatch(redirectToLogout());
        }
    }, [token, userProfile, loading, dispatch]);

    useEffect(() => {
        if (!tokenInStorage) {
            dispatch(redirectToLogout());
        }
    }, [tokenInStorage, dispatch]);

    if (!tokenInStorage || (!userProfile && loading && !token)) {
        return <Navigate to="/login" />;
    }

    if (tokenInStorage && !privacyPolicyAccepted) {
        return <Navigate to="/privacy_policy" />;
    }

    if (!userProfile && loading && !token) {
        return (
            <Navigate
                to={{ pathname: '/login', state: { from: props.location } }}
            />
        );
    }

    return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                return (
                    <>
                        <Component {...props} />
                    </>
                );
            }}
        />
    );
};

export { AuthProtected, AccessRoute };
